import { Pipe, PipeTransform } from '@angular/core';
import { UserDateFormat } from '@agilox/common';

@Pipe({
	name: 'dateFormatFormatter',
	standalone: false,
})
export class DateFormatFormatterPipe implements PipeTransform {
	transform(date: UserDateFormat): any {
		return date
			.replace(/-/g, '')
			.replace(/dot/g, '.')
			.replace(/slash/g, '/')
			.replace(/hyphen/g, '-')
			.replace(/m/g, 'M')
			.toUpperCase();
	}
}
